/* import __COLOCATED_TEMPLATE__ from './information-index.hbs'; */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './information-index.module.scss';

@classic
@tagName('')
export default class RequestInformationInformationIndex extends Component {
  styles = styles;
}
